$(function () {
    $(".lang-selector").on("click", function () {
        changeLanguage($(this).data("lang"));
    });
});
function changeLanguage(language) {
    $.ajax({
        url: "/language",
        type: "POST",
        data: {
            "language": language
        },
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    }).done(function (returndata) {
        console.log("Fine ajax");
        location.reload();
    });
}


